import {
    OTHER_EQUIPMENT_HOSPITAL_LIST,
    OTHER_EQUIPMENT_HOSPITAL_LIST_SUCCESS,
    OTHER_EQUIPMENT_HOSPITAL_LIST_ERROR,
    OTHER_EQUIPMENT_LIST,
    OTHER_EQUIPMENT_LIST_SUCCESS,
    OTHER_EQUIPMENT_LIST_ERROR,
    OTHER_EQUIPMENT_LIST_SEARCH_CHANGE,
    OTHER_EQUIPMENT_EDIT_MODAL_SET,
    OTHER_EQUIPMENT_EDIT_CHANGE_SET,
    OTHER_EQUIPMENT_EDIT,
    OTHER_EQUIPMENT_EDIT_SUCCESS,
    OTHER_EQUIPMENT_EDIT_ERROR,
    OTHER_EQUIPMENT_EQP,
    OTHER_EQUIPMENT_EQP_SUCCESS,
    OTHER_EQUIPMENT_EQP_ERROR
} from "../../actions";

const INIT_STATE = {
    loading: false,
    hospitallist: {
        loading: false,
        data: []
    },
    list: {
        loading: false,
        data: []
    },
    edit: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    equipment: {
        loading: false,
        data: []
    },
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            hospital: ''
        },
        value: {
            hospital: ''
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case OTHER_EQUIPMENT_HOSPITAL_LIST:
            return {
                ...state,
                loading: true,
                hospitallist: {
                    ...state.hospitallist
                }
            }
        case OTHER_EQUIPMENT_HOSPITAL_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                hospitallist: {
                    ...state.hospitallist,
                    ...action.payload
                }
            }
        case OTHER_EQUIPMENT_HOSPITAL_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case OTHER_EQUIPMENT_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }
        case OTHER_EQUIPMENT_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case OTHER_EQUIPMENT_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case OTHER_EQUIPMENT_LIST_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case OTHER_EQUIPMENT_EDIT_MODAL_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: action.payload
                }
            }
        case OTHER_EQUIPMENT_EDIT_CHANGE_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    data: {
                        ...state.edit.data,
                        ...action.payload
                    }
                }
            }
        case OTHER_EQUIPMENT_EDIT:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false
                }
            }
        case OTHER_EQUIPMENT_EDIT_SUCCESS:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case OTHER_EQUIPMENT_EDIT_ERROR:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case OTHER_EQUIPMENT_EQP:
            return {
                ...state,
                loading: true,
                equipment: {
                    ...state.equipment
                }
            }
        case OTHER_EQUIPMENT_EQP_SUCCESS:
            return {
                ...state,
                loading: false,
                equipment: {
                    ...state.equipment,
                    ...action.payload
                }
            }
        case OTHER_EQUIPMENT_EQP_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        default:
            return { ...state };
    }
};